module.exports = __webpack_public_path__ + "static/media/GA.2a9abfb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/GA.svg
// module id = 2154
// module chunks = 7